import config from "../../src/common/default_config";

export default class options extends config {
  // Kiosk settings
  static editor = "Mediahuis";
  static redirectReaderFromIframe = true;
  static returnToIframeUrl = "http://www.nieuwsblad.be/digitale-krant";
  static useSliderForArchive = true;
  static useSliderForPromospot = true;

  // SSO
  static SSOEnabled = true;
  static getSSOTokenFromUrl = true;
  static urlSSOTokenParameter = "token";
  static urlRedirectParameter = "goto";

  // Pdf options
  static page_ratio = 1.4745;
  static page_width_reference = 100000;
  static page_height_reference = 100000;
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfTablet = true;

  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "MHU1P",
  };

  // Reader options
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static printCroppedPdf = true;
  static pdfThreshold = { width: 825, height: 1050 }; // Make PDF render faster when zooming
  static zoomSteps = 5;

  // Social sharing
  static shareFromReader = true;
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    GooglePlus: false,
    Twitter: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "NB - ",
  };
}



// WEBPACK FOOTER //
// ./clients/mhu-nb/config.js